import PageStyle from "@/styles/components/share-cv/_index.module.scss";
import Button from "@/components/button";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Slider from "react-slick";
import { useState, useEffect, Image, useRef, useRouter } from '@/imports-files/common/common';
import ButtonStyle from "@/styles/components/button/_index.module.scss";
import Modal from "@/components/common-modal/modal";
import { InfoModalStyle } from "@/imports-files/components/common-modal/common-modal";


export function BrandGuide({setBrandModal}) 
{
  var settings = {
    dots: true,
    infinite: false,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: false,
    fade: true,
    responsive: [
      {
        breakpoint: 1280,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          infinite: true,
          dots: true
        }
      },
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          initialSlide: 1
        }
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
  };

  return (
    <Modal
    type="info"
      closeModal={() => setBrandModal(false)}
      className={`mt20 brandmodal`}
      largeWidth = {true}
      innerContent={
        <>
        <Slider {...settings}>
          <div>
              <h1 className={`${PageStyle.Sharecv__Heading} mb30`}>Page Example </h1>

              <img src="/images/pages/brand/page-demo.png" />
          </div>
          <div className={`mt0`}>
              <h1 className={`${PageStyle.Sharecv__Heading} mb30`}>Email Example </h1>
              <img src="/images/pages/brand/email-demo.png"/>
          </div>
        </Slider>
        <div className={`${InfoModalStyle.Modal__Container__ButtonSection} PositionRelative`}>
          <div className={PageStyle.SetupPopup__SubmitSectionAutomation}>
            <Button buttonstyle={ButtonStyle.primarybtn} type="button" onClick={() => setBrandModal(false)}>
              Got it
            </Button>
          </div>
        </div>
      </>
      }
    />
  ) 
}
